// useVersion can be used to remount component or forceUpdate functional component.
//
// Example 1. Remounting component.
//
// const [version, update] = useVersion();
// <Button onClick={update}>Reset table</Button>
// <Table key={version} />
//
// Example 2. Force component update. Of course, any useState or useReducer can be used instead of useVersion,
// but it looks less ugly at least.
//
// const Component = () => {
//   const [, rerender] = useVersion();
//   fetchApi(...).then(rerender);
// };

import { useReducer } from 'react';

const useVersion: () => [number, () => void] = () => useReducer((x) => x + 1, 0);

export default useVersion;
